import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuth, API } from "@/context/AuthContext";
import { Copy, Check, Send } from "lucide-react";
import { toast } from "sonner";

export default function FollowUps() {
    const { authHeaders } = useAuth();
    const [items, setItems] = useState([]);
    const [copied, setCopied] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const res = await axios.get(`${API}/templates/followups`, { headers: authHeaders() });
                setItems(res.data);
            } catch { /* noop */ }
        })();
    }, [authHeaders]);

    const copy = async (text, id) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(id);
            toast.success("Copied");
            setTimeout(() => setCopied(null), 1200);
        } catch {
            toast.error("Copy failed");
        }
    };

    return (
        <div data-testid="followups-page">
            <div className="mb-8">
                <div className="text-xs font-mono uppercase tracking-[0.2em] text-signal mb-2">/ FOLLOW-UP CADENCE</div>
                <h1 className="font-heading font-black text-4xl md:text-5xl tracking-tight">Never ghost. Never pester.</h1>
                <p className="text-zinc-400 mt-2">A clean sequence that respects the prospect and still moves the deal.</p>
            </div>

            <div className="space-y-4">
                {items.map((t) => (
                    <div key={t.id} className="border border-zinc-900 bg-[#0c0c0c] p-5" data-testid={`followup-${t.id}`}>
                        <div className="flex items-center justify-between gap-4 mb-3">
                            <div className="flex items-center gap-2">
                                <Send className="w-4 h-4 text-signal" strokeWidth={1.5} />
                                <span className="text-xs font-mono uppercase tracking-widest text-zinc-500">{t.category}</span>
                                <span className="text-xs text-zinc-600">·</span>
                                <span className="font-heading font-bold">{t.title}</span>
                            </div>
                            <button
                                onClick={() => copy(t.body, t.id)}
                                data-testid={`followup-copy-${t.id}`}
                                className="inline-flex items-center gap-2 border border-zinc-800 hover:border-zinc-600 text-zinc-300 hover:text-white px-3 py-1.5 rounded-md text-xs transition-colors"
                            >
                                {copied === t.id ? <><Check className="w-3 h-3" /> Copied</> : <><Copy className="w-3 h-3" /> Copy</>}
                            </button>
                        </div>
                        <p className="text-sm text-zinc-200 leading-relaxed whitespace-pre-wrap">{t.body}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}
